import { useState, useRef } from 'react';

import PropTypes from 'prop-types';
import { BsSend } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';
import TextInput from '#globalComponents/Forms/TextInput';

/**
 * Chat input bar for the agentic search conversation.
 */
const AgenticChatInput = ({ onSend, disabled }) => {
	const [value, setValue] = useState('');
	const inputRef = useRef(null);

	const handleSubmit = (e) => {
		e.preventDefault();
		const trimmed = value.trim();
		if (!trimmed || disabled) return;

		onSend(trimmed);
		setValue('');
		inputRef.current?.focus();
	};

	const handleKeyDown = (e) => {
		if (e.key === 'Enter' && !e.shiftKey) {
			e.preventDefault();
			handleSubmit(e);
		}
	};

	return (
		<form onSubmit={handleSubmit} className="flex items-center gap-2 px-3 py-2 border-t border-gray-200 bg-white">
			<TextInput
				ref={inputRef}
				value={value}
				onChange={(e) => setValue(e.target.value)}
				onKeyDown={handleKeyDown}
				placeholder="Beschreiben Sie Ihre Zielkunden..."
				disabled={disabled}
				className="flex-1"
			/>
			<Button type="submit" disabled={disabled || !value.trim()} aria-label="Senden">
				<BsSend className="w-4 h-4" />
			</Button>
		</form>
	);
};

AgenticChatInput.propTypes = {
	onSend: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
};

export default AgenticChatInput;
